"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mainContract = void 0;
const json_rpc_1 = require("@hediet/json-rpc");
const types_1 = require("./types");
exports.mainContract = (0, json_rpc_1.contract)({
    name: "service",
    client: {},
    server: {
        /* def */ ping: (0, json_rpc_1.requestType)({}),
        /* def */ getOrganizations: (0, json_rpc_1.requestType)({
            result: json_rpc_1.semanticJson.sObject({
                orgs: json_rpc_1.semanticJson.sArrayOf(types_1.sOrgOverview),
            }),
        }),
        /* def */ createOrganization: (0, json_rpc_1.requestType)({
            params: json_rpc_1.semanticJson.sObject({
                orgId: json_rpc_1.semanticJson.sString(),
                admins: json_rpc_1.semanticJson.sArrayOf(json_rpc_1.semanticJson.sString()),
            }),
        }),
        /* def */ deleteOrganization: (0, json_rpc_1.requestType)({
            params: json_rpc_1.semanticJson.sObject({
                orgId: json_rpc_1.semanticJson.sString(),
            }),
        }),
        /* def */ getOrgMemberships: (0, json_rpc_1.requestType)({
            params: json_rpc_1.semanticJson.sObject({
                orgId: json_rpc_1.semanticJson.sString(),
            }),
            result: json_rpc_1.semanticJson.sObject({
                members: json_rpc_1.semanticJson.sArrayOf(json_rpc_1.semanticJson.sObject({
                    userId: json_rpc_1.semanticJson.sNumber(),
                    username: json_rpc_1.semanticJson.sString(),
                    isAdmin: json_rpc_1.semanticJson.sBoolean(),
                })),
            }),
        }),
        /* def */ getProjectInfo: (0, json_rpc_1.requestType)({
            params: json_rpc_1.semanticJson.sObject({
                orgId: json_rpc_1.semanticJson.sString(),
                projectId: json_rpc_1.semanticJson.sString(),
            }),
            result: json_rpc_1.semanticJson.sObject({
                isAdmin: json_rpc_1.semanticJson.sBoolean(),
                canDeleteVersions: json_rpc_1.semanticJson.sBoolean(),
                canForkVersion: json_rpc_1.semanticJson.sBoolean(),
                canConfigureVersion: json_rpc_1.semanticJson.sBoolean(),
            }),
        }),
        /* def */ createProject: (0, json_rpc_1.requestType)({
            params: json_rpc_1.semanticJson.sObject({
                orgId: json_rpc_1.semanticJson.sString(),
                projectId: json_rpc_1.semanticJson.sString(),
            }),
            result: json_rpc_1.semanticJson.sObject({}),
        }),
        /* def */ updateOrgMembership: (0, json_rpc_1.requestType)({
            params: json_rpc_1.semanticJson.sObject({
                orgId: json_rpc_1.semanticJson.sString(),
                user: json_rpc_1.semanticJson.sUnion([
                    json_rpc_1.semanticJson.sObject({ username: json_rpc_1.semanticJson.sString() }),
                    json_rpc_1.semanticJson.sObject({ userId: json_rpc_1.semanticJson.sNumber() }),
                ]),
                state: json_rpc_1.semanticJson.sUnion([
                    json_rpc_1.semanticJson.sLiteral("none"),
                    json_rpc_1.semanticJson.sLiteral("member"),
                    json_rpc_1.semanticJson.sLiteral("admin"),
                ]),
            }),
        }),
        /* def */ createVersion: (0, json_rpc_1.requestType)({
            params: json_rpc_1.semanticJson.sObject({
                orgId: json_rpc_1.semanticJson.sString(),
                projectId: json_rpc_1.semanticJson.sString(),
                name: json_rpc_1.semanticJson.sString(),
                parents: json_rpc_1.semanticJson.sArrayOf(json_rpc_1.semanticJson.sObject({ versionId: json_rpc_1.semanticJson.sString() })),
            }),
            result: json_rpc_1.semanticJson.sObject({
                version: types_1.sVersionInfo,
            }),
        }),
        /* def */ deleteVersion: (0, json_rpc_1.requestType)({
            params: json_rpc_1.semanticJson.sObject({
                version: types_1.sVersionRef,
            }),
        }),
    },
});
/*
export const liveEditContract = contract({
    name: "liveEdit",
    client: {
        onTranslationChange: notificationType({
            params: s.sObject({
                version: sVersionRef,
                changedTranslations: sTranslationsForLanguageCode,
            }),
        }),
    },
    server: {
        subscribe: requestType({
            params: s.sObject({
                version: sVersionRef,
                languageCode: s.sString(),
            }),
        }),
    },
});
*/
//# sourceMappingURL=mainContract.js.map